/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Intro1Inputs */

const zh_pricing_faq5a_intro1 = /** @type {(inputs: Pricing_Faq5a_Intro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果您使用的是免费、高级、团队或商业计划，请按以下步骤取消：`)
};

const en_pricing_faq5a_intro1 = /** @type {(inputs: Pricing_Faq5a_Intro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you are on the Free, Premium, or Team or Business plan, follow the steps below to cancel your plan:`)
};

const es_pricing_faq5a_intro1 = /** @type {(inputs: Pricing_Faq5a_Intro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si estás en el plan Gratis, Premium, Equipo o Negocio, sigue estos pasos para cancelar tu plan:`)
};

/**
* | output |
* | --- |
* | "If you are on the Free, Premium, or Team or Business plan, follow the steps below to cancel your plan:" |
*
* @param {Pricing_Faq5a_Intro1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_intro1 = /** @type {((inputs?: Pricing_Faq5a_Intro1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Intro1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_intro1(inputs)
	if (locale === "en") return en_pricing_faq5a_intro1(inputs)
	return es_pricing_faq5a_intro1(inputs)
});
export { pricing_faq5a_intro1 as "pricing_faq5A_intro" }